 


<template>
  <v-container >
    <v-row justify="space-around" >
      <v-col cols="12" md="12" >
        <v-dialog
         
          transition="dialog-bottom-transition"
          width="auto"
          :model-value="modelValue"
          @update:modelValue="$emit('update:modelValue', $event)"
        >
          <template v-slot:activator="{ props: activatorProps }">
            <v-btn
              v-bind="activatorProps"
              text="Transition from Bottom"
              block
            ></v-btn>
          </template>

          <template v-slot:default="{ isActive }" >
            <v-card  class="pa-13" style=" ">
            
 
                <v-row>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to="/daily"
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="isActive.value = false"
                        >
                        <v-icon size="31" class="pb-3">mdi-newspaper-variant-outline</v-icon>
                        <p style="font-size: 9px;">Brief</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to="/trending"
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="isActive.value = false"
                        >
                        <v-icon size="31" class="pb-3">mdi-trending-up</v-icon>
                        <p style="font-size: 9px;">Trending</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to=""
                        variant="text"
                        stacked
                        class="pa-12"
                        style="visibility: hidden;"
                        @click="isActive.value = false"
                        >
                        <v-icon size="31" class="pb-3">mdi-notebook-outline</v-icon>
                        <p style="font-size: 9px;">Journals</p>
                        </v-btn>
                    </v-col>
        

                    <!--
                    <v-col cols="4" class="d-flex justify-center " >
                        <v-btn
                        to="/settings"
                        variant="text"
                        stacked
                        class="pa-12"
                        style="visibility: hidden;"
                        >
                        <v-icon size="31" class="pb-3">mdi-cog</v-icon>
                        <p style="font-size: 9px;">Settings</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to=""
                        variant="text"
                        stacked
                        class="pa-12"
                        >
                        <v-icon size="31" class="pb-3">mdi-filter</v-icon>
                        <p style="font-size: 9px;">Filter</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to=""
                        variant="text"
                        stacked
                        class="pa-12"
                        style="visibility: hidden;"
                        >
                        <v-icon size="31" class="pb-3">mdi-power</v-icon>
                        <p style="font-size: 9px;">Logout</p>
                        </v-btn>
                    </v-col>
                    -->
        



                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to="/settings"
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="isActive.value = false"
                        >
                        <v-icon size="31" class="pb-3">mdi-cog</v-icon>
                        <p style="font-size: 9px;">Settings</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to=""
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="toggleTheme"
                        
                        >
                        <v-icon size="31" class="pb-3">mdi-theme-light-dark</v-icon>
                        <p style="font-size: 9px;">Theme</p>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center ">
                        <v-btn
                        to=""
                        variant="text"
                        stacked
                        class="pa-12"
                        @click="onSignOut" 
                        >
                        <v-icon size="31" class="pb-3">mdi-power</v-icon>
                        <p style="font-size: 9px;">Logout</p>
                        </v-btn>
                    </v-col>
        
                </v-row>
                            

                    

              <v-card-actions class="justify-end">
                <v-btn
                  text="Close"
                  @click="isActive.value = false"
                ></v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
 
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  modelValue: Boolean,

  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' } 
})

defineEmits(["update:modelValue"])





// Dark Mode
import { useTheme } from 'vuetify';
import { watch } from 'vue';

const theme = useTheme();
const toggleTheme = () => {
  theme.global.name.value =
    theme.global.name.value === 'dark' ? 'light' : 'dark';
};
watch(
  () => theme.global.name.value,
  v => localStorage.setItem('theme', v)
);
theme.global.name.value = localStorage.getItem('theme') || 'light';


// Sign-out

 


</script>